import { Component } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { TranslatePipe } from '@ngx-translate/core';
import { BookDemoDirective } from '../../directives/book-demo.directive';

@Component({
  selector: 'maximizer-showcase-client-service-page',
  standalone: true,
  imports: [KENDO_BUTTON, TranslatePipe, BookDemoDirective],
  templateUrl: './client-service.page.html',
  styleUrl: './client-service.page.scss',
})
export class ClientServicePage {}
